export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Обзор открытой платформы',
  'pages.openapi.overview.loadFailed': 'Не удалось загрузить сводку использования (API может быть ещё не готов)',
  'pages.openapi.overview.docsTitle': 'Руководство по интеграции',
  'pages.openapi.overview.docsDesc':
    'BasePath открытой платформы: /v1. Конверт ответа: {code,message,data,request_id}. Для API Key передавайте Authorization: Bearer sk_live_... / sk_test_.... Открытый текст ключа показывается только один раз при создании или ротации — сохраните его надёжно.',
  'pages.openapi.overview.level': 'Текущий уровень',
  'pages.openapi.overview.qps': 'Лимит QPS',
  'pages.openapi.overview.apps': 'Приложения',
  'pages.openapi.overview.appsSuffix': '(макс. {maxApps}, ключей на приложение {maxKeys})',
  'pages.openapi.status.active': 'Активен',
  'pages.openapi.status.disabled': 'Отключён',
  'pages.openapi.apps.title': 'Приложения и ключи',
  'pages.openapi.apps.listTitle': 'Мои приложения',
  'pages.openapi.apps.create': 'Создать приложение',
  'pages.openapi.apps.createModal': 'Создать приложение',
  'pages.openapi.apps.name': 'Имя приложения',
  'pages.openapi.apps.nameRequired': 'Введите имя',
  'pages.openapi.apps.description': 'Описание',
  'pages.openapi.apps.status': 'Статус',
  'pages.openapi.apps.createdAt': 'Создано',
  'pages.openapi.apps.createSuccess': 'Приложение создано',
  'pages.openapi.apps.createFailed': 'Не удалось создать приложение',
  'pages.openapi.apps.loadFailed': 'Не удалось загрузить приложения',
  'pages.openapi.apps.keysLoadFailed': 'Не удалось загрузить ключи',
  'pages.openapi.apps.delete': 'Удалить',
  'pages.openapi.apps.deleteConfirm': 'Удалить это приложение?',
  'pages.openapi.apps.deleted': 'Удалено',
  'pages.openapi.apps.createKey': 'Создать Key',
  'pages.openapi.apps.createKeyModal': 'Создать API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Ключ создан',
  'pages.openapi.apps.keyCreateFailed': 'Не удалось создать ключ',
  'pages.openapi.apps.noPlainKey': 'Открытый ключ не возвращён',
  'pages.openapi.apps.plainKeyTitle': 'Сохраните ваш API Key',
  'pages.openapi.apps.plainKeyHint': 'Открытый текст показывается только один раз и недоступен после закрытия.',
  'pages.openapi.apps.copy': 'Копировать',
  'pages.openapi.apps.copied': 'Скопировано',
  'pages.openapi.apps.copyFailed': 'Не удалось скопировать; выберите вручную',
  'pages.openapi.apps.close': 'Закрыть',
  'pages.openapi.apps.key.name': 'Имя',
  'pages.openapi.apps.key.namePlaceholder': 'Основной продакшен-ключ',
  'pages.openapi.apps.key.prefix': 'Префикс',
  'pages.openapi.apps.key.env': 'Среда',
  'pages.openapi.apps.key.status': 'Статус',
  'pages.openapi.apps.key.createdAt': 'Создано',
  'pages.openapi.apps.key.disable': 'Отключить',
  'pages.openapi.apps.key.disableConfirm': 'Отключить этот ключ?',
  'pages.openapi.apps.key.disabled': 'Отключён',
  'pages.openapi.apps.key.enable': 'Включить',
  'pages.openapi.apps.key.enabled': 'Включён',
  'pages.openapi.apps.key.rotate': 'Ротация',
  'pages.openapi.apps.key.rotateConfirm': 'Ротация создаёт новый ключ и один раз возвращает открытый текст. Продолжить?',
  'pages.openapi.apps.key.rotated': 'Ротация выполнена',
  'pages.openapi.apps.key.delete': 'Удалить',
  'pages.openapi.apps.key.deleteConfirm': 'Удалить этот ключ? Это необратимо.',
  'pages.openapi.apps.key.deleted': 'Удалён',
  'pages.openapi.logs.title': 'Журнал использования',
  'pages.openapi.logs.listTitle': 'Детали вызовов',
  'pages.openapi.logs.dailyTitle': 'Использование за 14 дней',
  'pages.openapi.logs.dailyEmpty': 'Нет данных дневного использования',
  'pages.openapi.logs.date': 'Дата',
  'pages.openapi.logs.count': 'Вызовы',
  'pages.openapi.logs.createdAt': 'Время',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Вставьте request_id из ответа API',
  'pages.openapi.logs.detail': 'Подробности',
  'pages.openapi.logs.detailTitle': 'Детали вызова',
  'pages.openapi.logs.detailLoading': 'Загрузка…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Запрос',
  'pages.openapi.logs.responseBody': 'Ответ',
  'pages.openapi.logs.app': 'Приложение',
  'pages.openapi.logs.appId': 'ID приложения',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ID пользователя',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Префикс Key',
  'pages.openapi.logs.method': 'Метод',
  'pages.openapi.logs.path': 'Путь',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Бизнес-код',
  'pages.openapi.logs.latency': 'Задержка (мс)',
  'pages.openapi.logs.loadFailed': 'Не удалось загрузить',
  'pages.openapi.planTiers.title': 'Тарифы открытой платформы',
  'pages.openapi.planTiers.level': 'Уровень',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Название',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Дневная квота',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Макс. приложений',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Макс. ключей на приложение',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Сохранить',
  'pages.openapi.planTiers.saved': 'Сохранено',
  'pages.openapi.planTiers.saveFailed': 'Не удалось сохранить',
  'pages.openapi.planTiers.loadFailed': 'Не удалось загрузить тарифы',
  'pages.openapi.planTiers.readonly': 'Наблюдатели имеют только чтение и не могут менять тарифы',
  'pages.openapi.admin.usageLogsTitle': 'Аудит вызовов открытой платформы',
  'pages.openapi.admin.usageLogsList': 'Глобальный журнал вызовов',
  'pages.openapi.admin.disableKeyConfirm': 'Отключить этот API Key?',
  'pages.openapi.admin.disableKey': 'Отключить Key',
  'pages.openapi.admin.keyDisabled': 'Отключён',
  'pages.openapi.admin.appsTitle': 'Приложения открытой платформы',
  'pages.openapi.admin.appsList': 'Все приложения разработчиков',
  'pages.openapi.admin.developers': 'Разработчики',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Всего ключей',
  'pages.openapi.admin.activeKeys': 'Активные ключи',
  'pages.openapi.admin.todayRequests': 'Вызовы сегодня',
  'pages.openapi.admin.todayErrors': 'Ошибки сегодня',
  'pages.openapi.admin.errorCount': 'Ошибки',
  'pages.openapi.admin.owner': 'Владелец',
  'pages.openapi.admin.keyCount': 'Ключи',
  'pages.openapi.admin.keyword': 'Ключевое слово',
  'pages.openapi.admin.keywordPlaceholder': 'Имя приложения / описание / код арендатора',
  'pages.openapi.admin.statsLoadFailed': 'Не удалось загрузить статистику',
  'pages.openapi.admin.noKeys': 'Нет ключей',
  'pages.openapi.admin.appEnabled': 'Приложение включено',
  'pages.openapi.admin.appDisabled': 'Приложение отключено',
  'pages.openapi.admin.appDisableConfirm': 'Отключить это приложение?',
  'pages.openapi.admin.appEnableConfirm': 'Включить это приложение?',
  'pages.openapi.admin.keyEnableConfirm': 'Включить этот ключ?',
  'pages.admin.user.openapiDeveloperEnabled': 'Открытая платформа',
  'pages.admin.user.openapi.on': 'Включено',
  'pages.admin.user.openapi.off': 'Отключено',
  'pages.admin.user.openapiLevel': 'Уровень открытой платформы',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Включить разработчика',
  'pages.admin.user.openapiLevel.label': 'Уровень',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Использование за сегодня',
  'pages.openapi.apps.key.enableConfirm': 'Включить этот ключ?',
  'pages.admin.user.section.openapi': 'Открытая платформа',
};
